var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLinkWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-link-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-link-white",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29289322,7 L5.64644661,8.64644661 C5.45118446,8.84170876 5.45118446,9.15829124 5.64644661,9.35355339 C5.84170876,9.54881554 6.15829124,9.54881554 6.35355339,9.35355339 L8.35355339,7.35355339 C8.45119093,7.25591585 8.50000647,7.1279442 8.5,6.99997456 C8.773795,6.99724046 8.99490356,6.77444156 8.99490356,6.5 C8.99490356,6.22555844 8.773795,6.00275954 8.5,6.00002544 C8.50000647,5.8720558 8.45119093,5.74408415 8.35355339,5.64644661 L6.35355339,3.64644661 C6.15829124,3.45118446 5.84170876,3.45118446 5.64644661,3.64644661 C5.45118446,3.84170876 5.45118446,4.15829124 5.64644661,4.35355339 L7.29289322,6 L4.5,6 C4.22385763,6 4,6.22385763 4,6.5 C4,6.77614237 4.22385763,7 4.5,7 L7.29289322,7 Z M6.5,13 C2.91014913,13 0,10.0898509 0,6.5 C0,2.91014913 2.91014913,0 6.5,0 C10.0898509,0 13,2.91014913 13,6.5 C13,10.0898509 10.0898509,13 6.5,13 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLinkWhite);
export default __webpack_public_path__ + "static/media/arrow-link-white.f11e16619a37013a0dd934a55c11a61e.svg";
export { ForwardRef as ReactComponent };